import { cloneDeep, forEach } from "lodash";

const initialState = {
  wsTemplates: [],
  totalPages: 0,
  loadingWsTemplates: false
}

const wsTemplatesReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'START_WS_TEMPLATES_REQUEST':
      return {
        ...state,
        loadingWsTemplates: true
      };
    case 'END_WS_TEMPLATES_REQUEST':
      return {
        ...state,
        loadingWsTemplates: false
      };
    case 'SET_WS_TEMPLATES': {
      const { concat, data } = action;
      return {
        ...state,
        wsTemplates: concat ? state.wsTemplates.concat(data.ws_templates || []) : data.ws_templates,
        totalPages: data.total_pages
      };
    }
    case 'UPDATE_WS_TEMPLATE_STATUS': {
      let newWsTemplates = cloneDeep(state.wsTemplates);

      if (action.data.currentTab != 'ws_templates' || action.data.ws_template.status === 'deleted') {
        newWsTemplates = newWsTemplates.filter((wsTemplate) => (wsTemplate.id !== action.data.ws_template.id));
      }
      else {
        forEach(newWsTemplates, wsTemplate => {
          if (wsTemplate.id == action.data.ws_template.id) {
            wsTemplate.status = action.data.ws_template.status
          }
        });
      }

      return {
        ...state,
        wsTemplates: newWsTemplates
      };
    }

    case 'UPDATE_WS_TEMPLATE_TEAM': {
      let newWsTemplates = cloneDeep(state.wsTemplates);

      forEach(newWsTemplates, wsTemplate => {
        if (wsTemplate.id == action.data.ws_template.id) {
          wsTemplate.team = action.data.ws_template.team
        }
      });

      return {
        ...state,
        wsTemplates: newWsTemplates
      };
    }

    default:
      return state;
  }
};

export default wsTemplatesReducer;